import axios, { Axios } from 'axios';
import { stringify } from 'qs';
import type { AxiosRequestConfig, Method, AxiosResponse, AxiosError } from 'axios';
import { message } from 'antd';
import lodash from "lodash"
import { BASE_API } from './api.url';
const IP = localStorage.getItem("ip")
class GlobalAxios extends Axios {
  protected RequestConfig: AxiosRequestConfig;
  protected alertMsg: string;
  protected toastFlag: boolean;
  protected networkFlag: boolean = true;
  protected errorFlag: boolean = true;

  constructor(props: { axiosOptions: AxiosRequestConfig, alertMsg?: string, toastFlag?: boolean}) {
    const { axiosOptions, alertMsg = "", toastFlag = true } = props
    super(axiosOptions)
    this.RequestConfig = this.config(axiosOptions);
    this.alertMsg = alertMsg;
    this.toastFlag = toastFlag;
  }

  protected config(obj: AxiosRequestConfig) {
    const headers = obj.headers || {};
    const data: AxiosRequestConfig = {
      headers: {
        Accept: 'application/json',
        "accept-ip": IP,
        ...headers,
      },
      baseURL: BASE_API,
      paramsSerializer: (params) => {
        return stringify(params);
      },
      ...obj,
    };
    return data;
  }

  protected axiosError(error: AxiosError<any>) {
    console.log(`Error ${this.alertMsg} =>`, error)
    if (lodash.has(error, "response.status")) {
      message.error(error?.response?.data)
    }
    return error;
  }

  protected async http<P, R>(config: AxiosRequestConfig): Promise<{payload: P}> {
    const res: AxiosResponse<API.RequestAPI<P, AxiosError>, R> = await axios(config);
    //  console.log(`${config.method}---${this.alertMsg} Api---Return the result:`, {...res});
    if (res.data.status) {
      return { payload: res.data.payload };
    } else {
      return Promise.reject(this.axiosError(res.data.error))
    }
  }

  async fetch<P = any, R = any>(method?: Method, data?: R): Promise<{payload: P}>;
  async fetch<P, R>(method: Method = 'GET', data?: R): Promise<{payload: P}> {
    return this.mergeConfig<P, R>(method, data);
  }

  protected async mergeConfig<P, R>(method: Method, data?: R): Promise<{payload: P}> {
    const config = GlobalAxios.HeaderConfig({
      ...this.RequestConfig,
      method,
      ...(() => {
        if (method.toLocaleLowerCase() === 'get') {
          return { params: data };
        }
        return { data };
      })(),
    });
    // console.log(`${method}---${this.alertMsg} Api---Request configuration item`, config);
    return await this.http<P, R>(config);
  }

  // 添加新的 header
  static HeaderConfig(req: AxiosRequestConfig) {
    return req;
  }

  static async externalFetch(Url: string, init?: RequestInit | undefined) {
    try {
      const req = await fetch(Url, init);
      if (req.ok) {
        return req.json();
      }
    } catch (error) {
      return false;
    }
  }

}

axios.interceptors.response.use(
  async (config) => {
    try {
      if (config.status === 200) {
        config.data = {
          payload: config.data,
          status: true,
        };
      }
    } catch (error) {
    } finally {
      return config;
    }
  },
  (error) => {
    return { data: { status: false, error } };
  },
);

export { GlobalAxios };
